import { AddressModel } from './address.model';

export class RegistrationModel {
    _id: string;
    mobileNumber: number;
    emailId: string;
    password: string;
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    location: string;
    dial_code: string;
    gender: string;
    addressDetails: [AddressModel];
    result: string;
    userId: string;
    publish: boolean;
    createdBy: string;
    lastLoginBy: string;
    oldPwd: string;
    customer: any;
    guestCustomer: boolean;
    hasPromotional: boolean;
    hasNewsLetter: boolean;
}